import withTranslation from "next-translate/withTranslation";
import { Component } from "react";
import PricesDisplay from "./AveragePriceAreaComponents/PricesDisplay";

const isBrowser = () => typeof window !== "undefined";

export class AveragePriceArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      adresseDetailsError: false,
      areaLabel: "",
      noDataFound: false,
      coordinates: {
        lat: null,
        lng: null,
      },
      adressPrice: null,
      adressePriceVilla: null,
      waitForAdress: true,
      matches: isBrowser() && window.matchMedia("(min-width: 990px)").matches,
    };
  }

  componentDidMount() { }

  render() {

    const { t, lang } = this.props.i18n;

    if (this.props.prices.prix_appartement || this.props.prices.prix_villa) {
      return (
        <>
          <PricesDisplay
            indice_confiance_appartement={
              this.props.indice_confiance_appartement
            }
            indice_confiance_villa={this.props.indice_confiance_villa}
            t={t}
            lang={lang}
            localisation={this.props.localisation}
            last_update={this.props.prices.last_update}
            prix_appartement={this.props.prices.prix_appartement}
            prix_villa={this.props.prices.prix_villa}
          />
        </>
      );
    } else {
      return <></>;
    }
  }
}

export default withTranslation(AveragePriceArea, "prixImmobilierMaroc");
